<template>
  <div>
    <left-sidebar :ppa="ppa" />
    <right-sidebar :ppa="ppa" />
    <header-bp
      :user="user"
      :ppa="ppa"
    />
    <div class="header-spacer" />
    <div class="container">
      <div class="row main-categories">
        <main class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <h1>{{ date | formatDate('MMMM') }} {{ year }}</h1>
        </main>
      </div>
      <div class="row">
        <!-- Main Content-->
        <main class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-xs-12">
          <div
            data-layout="masonry"
            data-main_categories=".main-categories"
            class="row sorting-container"
          >
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 sorting-item money">
              <financial-table :date="date" />
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 sorting-item money">
              <financial-eco :date="date" />
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 sorting-item health">
              <week-review :date="date" />
            </div>
          </div>
        </main>
        <aside class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12">
          <div class="ui-block" />
          <calendar-container :date="date" />
          <today-questions :date="date" />
          <!--<today-emotions :date="date" />-->
          <to-do :date="date" />
        </aside>
      </div>
    </div>
    <a
      href="#"
      class="back-to-top"
    >
      <app-icon
        name="olymp-stats-arrow-icon"
        tooltip="Back to top"
        color="white"
        size="medium"
      />
    </a>
  </div>
</template>

<script>
import { format } from 'date-fns'
 // import './js/jquery-3.2.1';
 // import './js/material.min';
 // import './js/material-init';
import { mapState } from 'vuex'

import LeftSidebar from '../../components/common-apps/common/LeftSidebar'
import RightSidebar from '../../components/common-apps/common/RightSidebar'
import HeaderBp from '../../components/common-apps/common/HeaderBp'
import TodayQuestions from '../../components/personal/daily-questions/TodayQuestions'
// import TodayEmotions from '../../components/personal/emotions/TodayEmotions'
import FinancialTable from '../../components/personal/financial/FinancialTable'
import FinancialEco from '../../components/personal/financial/FinancialEco'
import WeekReview from '../../components/personal/week-review/WeekReview'
import CalendarContainer from '../../components/personal/calendar/CalendarContainerAnswer'
import ToDo from '../../components/personal/to-do/ToDo'
import AppIcon from "../../components/common-apps/common/AppIcon";

export default {
  name: 'Month',
  components: {
    LeftSidebar,
    RightSidebar,
    HeaderBp,
    TodayQuestions,
    //TodayEmotions,
    FinancialTable,
    FinancialEco,
    WeekReview,
    CalendarContainer,
    ToDo,
    AppIcon
  },
  data () {
    return {
      date: new Date(),
      month: format(new Date(),'MM'),
      year: format(new Date(),'yyyy')
    }
  },
  computed:
    mapState({
      ppa: state => state.account.ppa,
      user () {
        return !this.$store.getters['account/user'] ? { username: 'None' } : this.$store.getters['account/user']
      }
    }),
  mounted() {
    document.body.classList.add('month-page')
  },
  destroyed () {
    document.body.classList.remove('month-page')
  },
  created () {
    if (this.$route.params.month1 && this.$route.params.year) {
      let day = '01'
      if (this.month === this.$route.params.month1 && this.year === this.$route.params.year) {
        day = format(new Date(),'dd')
      }
      this.month = this.$route.params.month1
      this.year = this.$route.params.year
      this.date = new Date(`${this.year}-${this.month}-${day}T00:00:01`)
    }
    this.$store.dispatch('account/fetchUser')
  }
}

</script>

<style lang="scss">
  // Bootstrap from node_modules has container smaller
  @import '../../scss/Bootstrap/scss/bootstrap-reboot';
  @import '../../scss/Bootstrap/scss/bootstrap';
  @import '../../scss/Bootstrap/scss/bootstrap-grid';

  @import '../../scss/month';
  // @import '../../scss/fonts';

</style>
